import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// How close value / step must be to a whole number to count as a multiple,
// tolerating floating-point rounding error (e.g. 0.3 / 0.1 = 2.9999999999999996).
const STEP_TOLERANCE = 1e-6;

export function stepValidator(step: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null || control.value === undefined) {
      return null; // Don't validate empty values
    }

    const value = parseFloat(control.value as string);
    const stepsFromZero = value / step;
    const isValid =
      Math.abs(stepsFromZero - Math.round(stepsFromZero)) < STEP_TOLERANCE;

    return !isValid
      ? { step: { step, actual: control.value as number } }
      : null;
  };
}
